import React from "react";
import { Form, Checkbox, Select, Input, Row, Col } from "antd";
import "../BusinessSignupForm.css";

const Section7 = ({ formValues, setFormValues }) => {
  // Reusable checkbox grid renderer
  const renderCheckboxGrid = (options, value, onChange) => (
    <Checkbox.Group value={value || []} onChange={onChange} style={{ width: "100%" }}>
      <Row gutter={[0, 8]}>
        {options.map((item) => (
          <Col span={12} key={item}>
            <Checkbox value={item}>{item}</Checkbox>
          </Col>
        ))}
      </Row>
    </Checkbox.Group>
  );

  return (
    <Form layout="vertical">
      {/* Section Title */}
      <h2 style={{ marginBottom: "20px", color: "#333" }}>
        Section 7 – Competition & Timing
      </h2>

      {/* Q25 – Competition */}
      <Form.Item label="25. Who do you consider your competition? (Select all that apply)">
        {renderCheckboxGrid(
          [
            "Local businesses",
            "National or chain businesses",
            "Online or ecommerce sites",
            "Lower-price competitors",
            "Heavily-advertised competitors",
            "No direct competition",
            "Not sure",
            "Other",
          ],
          formValues.competition,
          (checked) => setFormValues({ ...formValues, competition: checked })
        )}

        {formValues.competition?.includes("Other") && (
          <Input
            placeholder="Please specify other competition"
            style={{ marginTop: 8 }}
            value={formValues.otherCompetition || ""}
            onChange={(e) =>
              setFormValues({ ...formValues, otherCompetition: e.target.value })
            }
          />
        )}
      </Form.Item>

      {/* Q26 – Competition Impact */}
      <Form.Item label="26. How does your competition affect your business? (Select all that apply)">
        {renderCheckboxGrid(
          [
            "They get more attention or traffic",
            "They offer lower prices",
            "They have stronger online/social presence",
            "They attract my target customers",
            "They limit my growth or visibility",
            "They don’t affect us much",
            "Not sure",
            "Other",
          ],
          formValues.competitionImpact,
          (checked) =>
            setFormValues({ ...formValues, competitionImpact: checked })
        )}

        {formValues.competitionImpact?.includes("Other") && (
          <Input
            placeholder="Please specify other impact"
            style={{ marginTop: 8 }}
            value={formValues.otherCompetitionImpact || ""}
            onChange={(e) =>
              setFormValues({ ...formValues, otherCompetitionImpact: e.target.value })
            }
          />
        )}
      </Form.Item>

      {/* Q27 – Start Timeline */}
      <Form.Item label="27. How soon are you looking to start promoting your business?">
        <Select
          placeholder="Select"
          value={formValues.startPromotion}
          onChange={(val) =>
            setFormValues({ ...formValues, startPromotion: val })
          }
        >
          <Select.Option value="ASAP">As soon as possible</Select.Option>
          <Select.Option value="NextMonth">Within the next month</Select.Option>
          <Select.Option value="1-3Months">In 1-3 months</Select.Option>
          <Select.Option value="MoreThan3">In more than 3 months</Select.Option>
          <Select.Option value="ExploringOptions">
            No set timeline / exploring options
          </Select.Option>
        </Select>
      </Form.Item>

      {/* Q28 – Budget */}
      <Form.Item label="28. What is your estimated advertising or marketing budget?">
        <Select
          placeholder="Select your estimated budget"
          value={formValues.budget}
          onChange={(val) => setFormValues({ ...formValues, budget: val })}
        >
          <Select.Option value="Under $10,000">Under $10,000</Select.Option>
          <Select.Option value="$10K-$25K">$10K-$25K</Select.Option>
          <Select.Option value="$26K-$35K">$26K-$35K</Select.Option>
          <Select.Option value="$36K-$50K">$36K-$50K</Select.Option>
          <Select.Option value="$51K-$100K">$51K-$100K</Select.Option>
          <Select.Option value="Over $100K">Over $100K</Select.Option>
        </Select>
      </Form.Item>
    </Form>
  );
};

export default Section7;
